import ListGroup from 'react-bootstrap/ListGroup';
import SoundLibrary from '../../services/SoundLibrary';
import React, { useMemo } from 'react';
import SoundCategoryListItem from './SoundCategoryListItem';
import { AutoSizer, List, ListRowRenderer, WindowScroller } from 'react-virtualized';

export interface SoundCategoryListProps {
  search: string;
  draggingDisabled?: boolean;
}

function SoundCategoryList({ search, draggingDisabled = false }: SoundCategoryListProps) {
  const categories = useMemo(() => {
    if (search.length) {
      const searchWords = search.toLowerCase().split(' ');
      return SoundLibrary.categories.filter(it => it.keywordsMatches(searchWords));
    }
    return SoundLibrary.categories;
  }, [search])

  const rowRenderer: ListRowRenderer = ({ key, style, index }) => {
    return <SoundCategoryListItem
      category={categories[index]}
      key={key}
      style={style}
      draggingDisabled={draggingDisabled}
    />
  }

  return <ListGroup>
    <WindowScroller>
      {({ height, isScrolling, onChildScroll, scrollTop }) => (
        <AutoSizer disableHeight>
          {({ width }) => (
            <List
              onScroll={onChildScroll}
              autoHeight
              height={height}
              isScrolling={isScrolling}
              rowCount={categories.length}
              rowHeight={85}
              rowRenderer={rowRenderer}
              scrollTop={scrollTop}
              width={width}
            />
          )}
        </AutoSizer>
      )}
    </WindowScroller>
  </ListGroup>;
}

export default SoundCategoryList;
